import { useResponsive } from 'ahooks';
import { QueryParamProvider } from 'providers/storefront/QueryProvider';
import { useEffect, useState } from 'react';
import StickyBox from 'react-sticky-box';
import { PcConfiguratorProvider } from 'utils/PcConfiguratorContext';
import PcModelBreadCrumbs from './PcModelBreadCrumbs';
import PcModelIntro from './PcModelIntro';
import PcModelOptions from './PcModelOptions';
import PcModelOverview from './PcModelOverview';
import PcModelSteps from './PcModelSteps';
import PcModelStepsNext from './PcModelStepsNext';
import styles, { global } from './styles';
import { useRouter } from 'next/router';

const PcModel = ({ pcModel, prices, stocks, pcConfigDoc, modelTheme }) => {
  const router = useRouter();
  const responsive = useResponsive();
  const productType = pcModel?.buildType?.build_type_name;
  const [navbar, setNavbar] = useState(false);
  const [navbarTablet, setNavbarTablet] = useState(false);
  const [navbarMobile, setNavbarMobile] = useState(false);
  useEffect(() => {
    router.pathname == '/pc-models/[uid]' &&
      document &&
      document.body.classList.add('customize-page-product');
  });

  const handleNavbar = () => {
    if (window.scrollY >= 603) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const handleNavbarMobile = () => {
    if (window.scrollY >= 333) {
      setNavbarMobile(true);
    } else {
      setNavbarMobile(false);
    }
  };
  const handleNavbarTablet = () => {
    if (window.scrollY >= 433) {
      setNavbarTablet(true);
    } else {
      setNavbarTablet(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleNavbar);

    return () => window.removeEventListener('scroll', handleNavbar);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleNavbarMobile);

    return () => window.removeEventListener('scroll', handleNavbarMobile);
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', handleNavbarTablet);

    return () => window.removeEventListener('scroll', handleNavbarTablet);
  }, []);

  return (
    <>
      <QueryParamProvider>
        <PcConfiguratorProvider
          pcModel={pcModel}
          prices={prices}
          stocks={stocks}
          pcConfigDoc={pcConfigDoc}
        >
          {/* <div className="pc-model-wrapper wrapper">
            <PcModelBreadCrumbs />
          </div> */}

          <div className="pc-model-wrapper ">
            <PcModelIntro modelTheme={modelTheme} />
          </div>

          <div id="pc-configurator" className="pc-configurator">
            <div className="pc-model-wrapper">
              <PcModelSteps
                navbar={navbar}
                navbarTablet={navbarTablet}
                navbarMobile={navbarMobile}
              />
            </div>

            <div className="pc-model-wrapper wrapper">
              <div
                className={`pc-model-config-container ${
                  navbar ? 'sticky-container-desktop' : ''
                } ${navbarTablet ? 'sticky-container-tablet' : ''} ${
                  navbarMobile ? 'sticky-container-mobile' : ''
                }`}
              >
                <div className="pc-model-config-options">
                  <PcModelOptions modelTheme={modelTheme}/>

                  <StickyBox
                    className="sticky-wrapper"
                    offsetTop={220}
                    bottom={responsive?.xs && !responsive?.sm}
                  >
                    <PcModelOverview productType={productType} />
                  </StickyBox>
                  {/* <div
                      className="sticky-wrapper"
                      // offsetTop={-1200}
                      // bottom={responsive?.xs && !responsive?.sm}
                    > */}
                  {/* <PcModelOverview productType={productType} /> */}
                  {/* </div> */}
                </div>
              </div>
            </div>

            <PcModelStepsNext productType={productType} hideMobile />
          </div>
        </PcConfiguratorProvider>
      </QueryParamProvider>

      <style jsx>{styles}</style>
      <style jsx>{global}</style>
    </>
  );
};

export default PcModel;
